import type { ParsedUrlQuery } from 'querystring';

const includeParamsList = ['o', 'p', 'f', 'd', 'searchHistory', 'highlight', 'ssugest'];

// TODO: keep order is only necessary for path matching with remembered data. when path matching is improved, the order should not be important, then simlpify this helper function
export const createFilteredQueryStringWithSameOrder = (asPath: string) => {
  const queryString = asPath.split('?')[1]?.split('#')[0];
  if (!queryString) {
    return '';
  }
  const params = queryString
    .split('&')
    .filter((param) => includeParamsList.includes(param.split('=')[0]));
  if (params.length === 0) {
    return '';
  }
  return `?${params.map((param) => `${param.split('=')[0]}=${param.split('=')[1]}`).join('&')}`;
};

export const createSearchQueryString = (asPath: string, query: ParsedUrlQuery) => {
  if (!query['nav-q']) {
    return '#';
  }
  const filteredQueryString = createFilteredQueryStringWithSameOrder(asPath);
  return `/s/${query.searchquery}/${filteredQueryString}`;
};
